/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { useSelector } from 'react-redux';

import { BookingTab } from '../../components/FacilityPage/BookingTab';

export function BookingTabContainer() {
    const facilityData = useSelector((state) => state.timedEntry.facility);

    const { booking_windows_section: bookingWindowsHtml } = facilityData;

    return <BookingTab bookingWindowsHtml={bookingWindowsHtml} />;
}
